/* eslint-disable @typescript-eslint/no-unused-vars */
import { CommonTable } from "../common/common-list/table/Table";
import { KTCard } from "../../../../_metronic/helpers";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pagination } from "../common/common-list/components/pagination/Pagination";
import { setId } from "../../../../redux/features/shared/sharedSlice";
import { SubscriptionTiersModal } from "./SubscriptionTiersModal";
import { UserListHeader } from "../common/common-list/components/header/UserListHeader";
import { subscriptionTiersColumns } from "../common/common-list/table/columns/_subscriptionTiersColumns";
import { getSubscriptionTiers } from "../../../../redux/features/subscriptionTiers/_subscriptionTiersAction";

const SubscriptionTiersList = () => {
  const dispatch: any = useDispatch();
  const totalRecord = useSelector((state: any) => state.subscriptionTiersList?.totalRecord);
  const tierList = useSelector((state: any) => state?.subscriptionTiersList?.data);
  const sharedActions = useSelector((state: any) => state.sharedActions);

  useEffect(() => {
    dispatch(setId('SubscriptionTier'))
    dispatch(getSubscriptionTiers({ page: 1, limit: 10 }));
  }, [dispatch]);

  const handleClick = (page: number) => {
    dispatch(getSubscriptionTiers({ page: page, limit: 10 }));
  };

  return (
    <>
      <KTCard>
        <UserListHeader />
        <CommonTable data={tierList} columns={subscriptionTiersColumns} />
        {sharedActions?.subscriptionTiersModal &&
          <SubscriptionTiersModal />
        }
        {totalRecord > 10 && <Pagination
          totalRecord={totalRecord}
          handleClick={handleClick}
        />}
      </KTCard>
    </>
  );
};

export { SubscriptionTiersList };
